import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SimpleLayout = ({ children, title, backTo }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const currentPath = location.pathname;
    if (currentPath === "/terms" || currentPath === "/privacy") {
      navigate(-1);
    } else {
      navigate(backTo);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#F7F8FA] relative">
      <div>
        <div className='h-[53px] bg-[#F7F8FA] w-full'></div>
        <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center fixed w-full z-[999] top-0">
          <div className='flex items-center justify-between w-full'>
            <div className='flex items-center'>
              <div onClick={handleBack} className="flex items-center text-gray-600 hover:text-gray-900 mr-4 cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
                <span className="hidden sm:inline ml-1">Back</span>
              </div>
              <h1 className="text-lg font-medium">{title}</h1>
            </div>
          </div>
        </header>
      </div>
      <main className="flex-1 overflow-auto pt-[53px]">
        {children}
      </main>
    </div>
  );
};

export default SimpleLayout;
